import React from "react";
import * as styles from "./Icon.css";
import { getEnv } from "@utils/getEnv";

export type IconName =
  | "add"
  | "armed_shield_solid"
  | "attention"
  | "audio_clips"
  | "camera"
  | "checkmark"
  | "clip"
  | "clips_with_play"
  | "close_cancel"
  | "cloud_download"
  | "control_down"
  | "control_left"
  | "control_right"
  | "control_up"
  | "cycle"
  | "date"
  | "install_guide"
  | "mail"
  | "microphone"
  | "microphone_all"
  | "more"
  | "move_system"
  | "play-test-audio"
  | "radial_alert"
  | "radial_check"
  | "radial_info"
  | "radial_question"
  | "history"
  | "settings"
  | "switch"
  | "trash"
  | "troubleshooting"
  | "var_box"
  | "visibility_off"
  | "visibility"
  | "xc_cameras"
  | "xv_speaker";

type IconSvgProps = React.SVGProps<SVGSVGElement> & {
  size?: string;
  color?: string;
  hoverColor?: string;
  name: IconName;
};

export const IconSvg: React.FC<IconSvgProps> = ({
  size,
  color,
  hoverColor,
  style,
  name,
  ...props
}) => {
  const isStorybook = getEnv("VITE_STORYBOOK") === "true";

  const spritePath = isStorybook ? "/sprite.svg" : "assets/img/sprite.svg";

  const customStyle: React.CSSProperties = {
    ...style,
    width: size || "1em",
    height: size || "1em",
    fontSize: size || "var(--measure-font-16)",
    fill: color || "currentColor",
    transition: "fill 0.2s ease-in-out",
    ...(hoverColor &&
      ({
        "--icon-hover-fill": hoverColor,
      } as React.CSSProperties)),
  };

  return (
    <svg
      className={styles.iconSvg}
      style={customStyle}
      onMouseEnter={(e) => {
        if (hoverColor)
          (e.currentTarget as SVGSVGElement).style.fill = hoverColor;
      }}
      onMouseLeave={(e) => {
        (e.currentTarget as SVGSVGElement).style.fill = color || "currentColor";
      }}
      {...props}
    >
      <use xlinkHref={`${spritePath}#icon-${name}`} />
    </svg>
  );
};

export default IconSvg;
